import React, { useMemo } from 'react';
import { USER_KEY, PRINT_ORDER } from "../../const";
import { convertOrderStatus, numberFormat } from '../../helper';
import moment from "moment";

// bootstrap
import { Table } from "react-bootstrap";

function BillOrderDetailA4V2(props) {
    const userData = JSON.parse(localStorage.getItem(USER_KEY))?.data;
    const status = JSON.parse(localStorage.getItem(PRINT_ORDER))?.status || ""; 
    const free = useMemo(() => props?.orderGroup?.orders?.filter((e) => e?.amountFree > 0), [props?.orderGroup?.orders]);  

    // map currency
    const mapCurrency = (currency) => {
        switch (currency) {
            case "LAK":
            case "ກີບ":
                return "₭";
            case "BAHT":
            case "ບາດ":
                return "฿";
            case "USD":
            case "ໂດລາ":
                return "$";
            default:
                return "₭";
        }
    }

    return (
        <div style={{ padding: "15px 25px", backgroundColor: "#fff", boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
            {/* Header with shop info */}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "left",
                    marginBottom: "15px"
                }}
            >
                <h2 style={{ fontSize: "20px", marginBottom: "5px", fontWeight: "bold" }}>{userData?.shop?.name} (ວິສາຫະກິດສ່ວນບຸກຄົນ)</h2>
                <p style={{ margin: "2px 0", fontSize: "14px" }}>
                    {userData?.shop?.desc ? `${userData?.shop?.desc},` : ""} {" "}
                    {userData?.shop?.address?.village ? `${userData?.shop?.address?.village},` : ""} {" "}
                    {userData?.shop?.address?.district ? `${userData?.shop?.address?.district},` : ""} {" "}
                    {userData?.shop?.address?.province}
                </p>
                <p style={{ marginBottom: "2px", fontSize: "14px" }}>ໂທ: 020 {userData?.shop?.phone}, {userData?.shop?.phoneSeconde}</p>
                <div
                    style={{
                    display: "flex",
                    marginTop: "1px",
                    marginBottom: "8px",
                    gap: "8px"
                    }}>
                    {/* Customer Info */}
                    <div
                    style={{
                        width: "50%",
                        padding: "8px",
                        borderRadius: "5px",
                        border: "1px solid #e0e0e0",
                        backgroundColor: "#f8f9fa",
                        fontSize: "11px"
                    }}>
                        <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "3px" }}>ຂໍ້ມູນລູກຄ້າ</div>
                        <div style={{ marginBottom: "2px" }}>
                            <span style={{ fontWeight: "bold" }}>ພ/ງຂາຍ:</span> {props?.orderGroup?.createdBy?.firstName} {props?.orderGroup?.createdBy?.lastName ? props?.orderGroup?.createdBy?.lastName : props?.orderGroup?.createdBy?.nickname}
                        </div>
                        <div style={{ marginBottom: "2px" }}>
                            <span style={{ fontWeight: "bold" }}>ລູກຄ້າ:</span> {props?.orderGroup?.customerName} {props?.orderGroup?.customerLastName}
                        </div>
                        <div>
                            <span style={{ fontWeight: "bold" }}>ເບີໂທ:</span> {props?.orderGroup?.phone}
                        </div>
                        <div style={{ marginBottom: "2px" }}>
                            <span style={{ fontWeight: "bold" }}>ທີ່ຢູ່:</span> {props?.orderGroup?.village ? props?.orderGroup?.village + ", " : ""}
                            {props?.orderGroup?.district ? props?.orderGroup?.district + ", " : ""}
                            {props?.orderGroup?.province ? props?.orderGroup?.province : ""}
                        </div>
                    </div>
                    
                    {/* Invoice Info */}
                    <div
                    style={{
                        width: "50%",
                        padding: "8px",
                        borderRadius: "5px",
                        border: "1px solid #e0e0e0",
                        backgroundColor: "#f8f9fa",
                        display: "flex",
                        flexDirection: "column",
                        // justifyContent: "center",
                        fontSize: "11px"
                    }}>
                        <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "3px" }}>ຂໍ້ມູນໃບບິນ</div>
                        <div style={{ marginBottom: "2px" }}>
                            <span style={{ fontWeight: "bold" }}>ເລກທີບິນ:</span> {props?.orderGroup?.code}
                        </div>
                        <div>
                            <span style={{ fontWeight: "bold" }}>ວັນທີ:</span> {moment().format("DD/MM/YYYY HH:mm:ss")}
                        </div>
                        <div>
                            <span style={{ fontWeight: "bold" }}>ສະຖານະ: </span>
                            {props?.orderGroup?.debt > 0 ? "ຄ້າງໜີ້" : convertOrderStatus(status)}
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Product table */}
            <Table responsive style={{ marginTop: "5px", border: "1px solid #ddd", borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                        <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", width: "40px" }}>ລຳດັບ</th>
                        <th style={{ padding: "8px", border: "1px solid #ddd", width: "40%" }}>ລາຍການ</th>
                        <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", width: "60px" }}>ຫນ່ວຍ</th>
                        <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", width: "60px" }}>ຈຳນວນ</th>
                        {
                            free?.length > 0 && (
                                <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", width: "60px" }}>ແຖມ</th>
                            )
                        }
                        <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "right", width: "80px" }}>ລາຄາ</th>
                        <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "right", width: "80px" }}>ລວມ</th>
                    </tr>
                </thead>
                <tbody>
                    {props?.orderGroup?.orders?.length > 0 ? (
                        props?.orderGroup?.orders?.slice()
                            .sort((a, b) => parseInt(a.sortId) - parseInt(b.sortId))
                            .map((e, index) => (
                                <React.Fragment key={`order-${index}`}>
                                    <tr>
                                        <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", fontSize: "14px" }}>{index + 1}</td>
                                        <td style={{ padding: "8px", border: "1px solid #ddd", fontSize: "14px" }}>{e?.productName || ""}</td>
                                        <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", fontSize: "14px" }}>{e?.unit || ""}</td>
                                        <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", fontSize: "14px" }}>{e?.amount || ""}</td>{
                                            e?.amountFree && (
                                                <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", fontSize: "14px" }}>{e?.amountFree || "0"}</td>
                                            )
                                        }
                                        <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "right", fontSize: "14px" }}>
                                            {(() => {
                                                if (!e) return "Loading...";
                                                const basePrice = parseInt(e?.price || 0);
                                                const optionPrice = (e?.options || []).reduce(
                                                    (acc, item) => acc + (item?.price || 0),
                                                    0
                                                );
                                                return `${numberFormat(basePrice + optionPrice)}`;
                                            })()}
                                            {mapCurrency(e?.currency)}
                                        </td>
                                        <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "right", fontSize: "14px" }}>{numberFormat(e?.totalPrice || 0)}{mapCurrency(e?.currency)}</td>
                                    </tr>
                                    
                                    {/* Order children */}
                                    {e?.children?.length > 0 && 
                                        e?.children?.map((child, childIndex) => (
                                            <tr key={`child-${index}-${childIndex}`}>
                                                <td style={{ padding: "8px", border: "1px solid #ddd", fontSize: "14px", textAlign: "center" }} className="ps-4">
                                                    {index+1}.{childIndex+1}
                                                </td>
                                                <td style={{ padding: "8px", border: "1px solid #ddd", fontSize: "14px" }}>{child?.productCode || ""}</td>
                                                <td style={{ padding: "8px", border: "1px solid #ddd", fontSize: "14px" }}>{child?.productName || ""}</td>
                                                <td style={{ padding: "8px", border: "1px solid #ddd", fontSize: "14px", textAlign: "center" }}>{child?.unit || ""}</td>
                                                <td style={{ padding: "8px", border: "1px solid #ddd", fontSize: "14px", textAlign: "center" }}>
                                                    {child?.amount ?? child?.volume ?? ""}
                                                </td>
                                                <td style={{ padding: "8px", border: "1px solid #ddd", fontSize: "14px", textAlign: "right" }}>{numberFormat(child?.price || 0)}</td>
                                                <td style={{ padding: "8px", border: "1px solid #ddd", fontSize: "14px", textAlign: "right" }}>{numberFormat(child?.totalPrice || 0)}</td>
                                            </tr>
                                        ))
                                    }
                                </React.Fragment>
                            ))
                    ) : (
                        // Example row to match the image when no data is available
                        <tr>
                            <td colSpan={6} style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center" }}>ບໍ່ພົບຂໍ້ມູນ</td>
                        </tr>
                    )}
                    <tr>
                        <td colSpan={2} style={{ border: "1px solid #ddd" }}>
                            {/* Product note */}
                            <div style={{ marginTop: "10px", marginBottom: "10px", fontStyle: "italic", textAlign: "center" }}>
                                <p style={{ fontSize: "14px" }}>*ສິນຄ້າບໍ່ສາມາດຄືນໄດ້*</p>
                            </div>
                        </td>
                        <td colSpan={5} style={{ border: "1px solid #ddd" }}>
                            {/* Payment summary */}
                            <div style={{ marginTop: "10px", display: "flex", justifyContent: "flex-end" }}>
                                <div style={{ width: "340px" }}>
                                    {
                                        props?.orderGroup?.discount > 0 && (
                                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                                                <span style={{ fontSize: "14px" }}>ສ່ວນຫລຸດ:</span>
                                                <span style={{ fontSize: "14px" }}>{numberFormat(props?.orderGroup?.discount || 0)} {props?.orderGroup?.discountType ? "₭" : "%" }</span>
                                            </div>
                                        )
                                    }
                                    {
                                        props?.orderGroup?.totalPrice > 0 && (
                                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                                                <span style={{ fontSize: "14px" }}>ລວມມູນຄ່າ:</span>
                                                <span style={{ fontSize: "14px", marginBottom: "1px" }}>
                                                    {numberFormat(props?.orderGroup?.totalPrice ?? 0)} ₭
                                                </span>
                                            </div>
                                        )
                                    }
                                    {
                                        props?.orderGroup?.sumPriceBaht > 0 && (
                                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                                                <span style={{ fontSize: "14px" }}></span>
                                                <span style={{ fontSize: "14px", marginBottom: "1px" }}>
                                                    {numberFormat(props?.orderGroup?.sumPriceBaht ?? 0)} ฿
                                                </span>
                                            </div>
                                        )
                                    }
                                    {
                                        props?.orderGroup?.sumPriceUsd > 0 && (
                                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                                                <span style={{ fontSize: "14px" }}></span>
                                                <span style={{ fontSize: "14px" }}>
                                                    {numberFormat(props?.orderGroup?.sumPriceUsd ?? 0)} $
                                                </span>
                                            </div>
                                        )
                                    }
                                    <div style={{ display: "flex", justifyContent: "space-between", borderTop: "1px solid #ddd", paddingTop: "5px" }}>
                                        <span style={{ fontWeight: "bold", fontSize: "14px" }}>ລວມທັງໝົດ:</span>
                                        <span style={{ fontWeight: "bold", fontSize: "14px" }}>{numberFormat(props?.orderGroup?.sumPrice || 0)} ₭</span>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </Table>
            
            {/* Signature Section */}
            <div style={{ marginTop: "1px" }}>
                {/* Signature Section */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                    }}
                >
                    <div style={{ width: "30%", textAlign: "center" }}>
                        <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "1px" }}>ວິທີການຊຳລະເງິນ</div>
                        <div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "2px" }}>
                                <input 
                                    type="checkbox" 
                                    id="cash" 
                                    checked={props?.orderGroup?.cash > 0 || (!props?.orderGroup?.transfer && !props?.orderGroup?.debt && props.activeTab === "CASH")}
                                    readOnly
                                    style={{ marginRight: "5px" }}
                                />
                                <label htmlFor="cash" style={{ fontSize: "14px" }}>ເງິນສົດ</label>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "2px" }}>
                                <input 
                                    type="checkbox" 
                                    id="transfer" 
                                    checked={props?.orderGroup?.transfer > 0 || props.activeTab === "TRANSFER"}
                                    readOnly
                                    style={{ marginRight: "5px" }}
                                />
                                <label htmlFor="transfer" style={{ fontSize: "14px" }}>ເງິນໂອນ</label>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <input 
                                    type="checkbox" 
                                    id="debt" 
                                    checked={props?.orderGroup?.debt > 0}
                                    readOnly
                                    style={{ marginRight: "5px" }}
                                />
                                <label htmlFor="debt" style={{ fontSize: "14px" }}>ຕິດຫນີ້</label>
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "30%", textAlign: "center" }}>
                        <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "70px" }}>ຜູ້ຮັບເງິນ</div>
                        <div style={{ borderTop: "1px solid #333", width: "80%", margin: "0 auto" }}></div>
                    </div>
                    <div style={{ width: "30%", textAlign: "center" }}>
                        <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "70px" }}>ຜູ້ຮັບເຄື່ອງ</div>
                        <div style={{ borderTop: "1px solid #333", width: "80%", margin: "0 auto" }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BillOrderDetailA4V2;